/* eslint-disable react/jsx-no-undef */
/* eslint-disable no-script-url,jsx-a11y/anchor-is-valid */
import React, { useEffect } from "react";
// import objectPath from "object-path";
import ApexCharts from "apexcharts";
// import {useHtmlClassService} from "../../../../_metronic/layout";
import {KTUtil} from '../../../../_metronic/_assets/js/components/util';

const moneyFormater = new Intl.NumberFormat("en-US", {
  style: "currency",
  currency: "PGK"
});

const currentYr = new Date().getFullYear();

export function RevenueByMonth({ className, data }) {
  
  // const uiService = useHtmlClassService();

  // const layoutProps = useMemo(() => {
    
  //   return {
  //     colorsGrayGray100: objectPath.get(uiService.config, "js.colors.gray.gray100"),
  //     colorsGrayGray700: objectPath.get(uiService.config, "js.colors.gray.gray700"),
  //     colorsThemeBaseSuccess: objectPath.get(
  //         uiService.config,
  //         "js.colors.theme.base.success"
  //     ),
  //     colorsThemeLightSuccess: objectPath.get(
  //         uiService.config,
  //         "js.colors.theme.light.success"
  //     ),
  //     fontFamily: objectPath.get(uiService.config, "js.fontFamily")
  //   };
  // }, [uiService]);

  useEffect(() => {
    if(Array.isArray(data) && data.length === 0){
      return;
    }

    const revenueChart = document.getElementById("revenue_by_month_dashboard");
    const year = new Date().getFullYear();
    
    let revenueData = data.filter( rv => rv.year === `${year}`);
    let revSum = 0;
    revenueData.forEach(rv => { revSum = revSum + rv.revenue });
   
    revenueData = revenueData.sort((a, b) => {
      return a.month_digit - b.month_digit;
    });

    let months = revenueData.map(rv => ( rv.month_name.substring(0, 3)));
    let rev = revenueData.map(rv => rv.revenue);
    
    const height = parseInt(KTUtil.css(revenueChart, 'height'));
    const options = getChartOptions(height, rev, months, revSum);
    
    const chart = new ApexCharts(revenueChart, options);
    chart.render();

    return function cleanUp() {
      chart.destroy();
    };

  }, [data]);

  function getChartOptions(height, revenueData, months, totalRevenue) {
    const options = {
      series: [
        {
          name: "Revenue",
          data: revenueData,
        }
      ],
      chart: {
        height: height,
        type: "bar"
      },
      plotOptions: {
        bar: {
          borderRadius: 10,
          dataLabels: {
            position: "top",
          },
        },
      },
      dataLabels: {
        enabled: false,
        formatter: function(val) {
          return moneyFormater.format(val).replace(/\s/g, '').replace("PGK", "K");
        },
        offsetY: -20,
        style: {
          fontSize: "12px",
          colors: ["#304758"],
        },
      },
      tooltip: {
        y: {
          formatter: function (val){
            return moneyFormater.format(val).replace(/\s/g, '').replace("PGK", "K");
          }
        }
      },
      xaxis: {
        categories: months,
        position: "bottom",
        axisBorder: {
          show: false,
        },
        axisTicks: {
          show: false,
        },
        crosshairs: {
          fill: {
            type: "gradient",
            gradient: {
              colorFrom: "#D8E3F0",
              colorTo: "#BED1E6",
              stops: [0, 100],
              opacityFrom: 0.4,
              opacityTo: 0.5,
            },
          },
        },
      },
      yaxis: {
        axisBorder: {
          show: false,
        },
        axisTicks: {
          show: false,
        },
        labels: {
          show: false
        },
      },
      title: {
        text: moneyFormater.format(totalRevenue).replace(/\s/g, '').replace("PGK", "K"),
        offsetX: 30,
        style: {
          fontSize: '30px',
          fontFamily: `-apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen, Ubuntu, Cantarell, 'Open Sans', 'Helvetica Neue', sans-serif`,
          cssClass: 'apexcharts-yaxis-title'
        }
      },
      subtitle: {
        text: `Total Revenue, ${currentYr}`,
        offsetY: 50,
        offsetX: 30,
        style: {
          fontSize: '18px',
          fontFamily: `-apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen, Ubuntu, Cantarell, 'Open Sans', 'Helvetica Neue', sans-serif`,
          cssClass: 'apexcharts-yaxis-title'
        }
      }
    };
    return options;
  };


  return (
    <div className={`card card-custom ${className}`}>

      {/* Header */}
      <div className="card-header border-0 pt-5">
        <h3 className="card-title font-weight-bolder">Revenue By Month</h3>
        {/* <div className="card-toolbar">

        </div> */}
      </div>

      {/* Body */}
      <div className="card-body d-flex flex-column">
        <div className="flex-grow-1">
          <div id="revenue_by_month_dashboard" style={{height: "300px"}}></div>
        </div>
        {/* <div className="pt-5">
          <p className="text-center font-weight-normal font-size-lg pb-7">
            Notes: Current sprint requires stakeholders<br/>
            to approve newly amended policies
          </p>
          <a href="#" className="btn btn-success btn-shadow-hover font-weight-bolder w-100 py-3">Generate Report</a>
        </div> */}
      </div>
    </div>
  );
};
